import React from 'react';
import { apiResource, appUrl } from '../../../utils';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function EventCard({ event }) {
  const history = useHistory();

  const price = event.min_price_ticket_event_zone === '0.00' ? 'Gratis' : `${event.name_money} ${event.min_price_ticket_event_zone}`;
  const soldOut = event.sold_out === 1;

  return (
    <div className="card event-card shadow-sm" onClick={() => {
      history.push(appUrl({ url: event.slug_event_formatted }));
    }} style={{ cursor: 'pointer' }}>
      <div style={{ position: 'relative', overflow: 'hidden', borderRadius: '0.375rem 0.375rem 0 0' }}>
        <img
          src={apiResource({ url: event.banner_small_event })}
          alt={event.name_event}
          className="card-img-top"
          style={{ height: '250px', objectFit: 'cover' }}
        />
        {soldOut && <div className="sold-out-overlay">AGOTADO</div>}
      </div>

      <div className="card-body">
        {/* Category and status */}
        <div className="d-flex align-items-center gap-2 mb-3">
          <span className="text-primary-custom fw-bold" style={{ fontSize: '11px', letterSpacing: '0.05em' }}>
            {event.name_type_event}
          </span>
          {event.sold_out === 0 && <span className="text-secondary-emphasis" style={{ fontSize: '12px' }}>• Presencial</span>}
        </div>

        {/* Event name */}
        <h5
          className="card-title fw-bold text-dark mb-3"
          style={{
            fontSize: '18px',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {event.name_event}
        </h5>

        {/* Location and date */}
        <div className="mb-3">
          <p className="card-text text-secondary mb-1" style={{ fontSize: '14px' }}>
            <i className="fas fa-map-marker-alt me-2" style={{ color: 'var(--primary-color)' }}></i>
            {event.location_event}
          </p>
          <p className="card-text text-secondary" style={{ fontSize: '14px' }}>
            <i className="fas fa-calendar me-2" style={{ color: 'var(--primary-color)' }}></i>
            {event.date_formmatted_event}
          </p>
        </div>

        {/* Price */}
        <div className="border-top pt-2">
          <p className="card-text fw-semibold text-dark mb-0">
            desde <span className="text-primary-custom">{price}</span>
          </p>
        </div>
      </div>
    </div>
  );
}